import { Observable } from 'rxjs';

import {
  ApplicationGlobalSettingRequest,
  ApplicationGlobalSettingResponse,
  CreateApplicationGlobalSettingRequest,
  UpdateApplicationGlobalSettingRequest,
} from '../data/models/application-setting.model';

import httpService from './httpService';

class SettingsService {
  private readonly apiLookupBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiLookupBase =
      __environment__.REACT_APP_GLOBAL_SETTINGS_API_URL?.trim();
  }

  public getApplicationGlobalSetting(
    payload: ApplicationGlobalSettingRequest | number | undefined,
  ): Observable<ApplicationGlobalSettingResponse[]> {
    let url = `${this.apiLookupBase}`;
    if (typeof payload === 'number') {
      url = `${this.apiLookupBase}/${payload}`;
    } else if (
      payload !== undefined &&
      typeof payload === 'object' &&
      'applicationTitleBC' in payload &&
      'applicationSettingBC' in payload
    ) {
      url = `${this.apiLookupBase}?applicationTitleBC=${
        (payload as ApplicationGlobalSettingRequest).applicationTitleBC
      }&applicationSettingBC=${
        (payload as ApplicationGlobalSettingRequest).applicationSettingBC
      }`;
    }
    return httpService.getJSON(url);
  }

  public getApplicationGlobalSettings(
    payload: ApplicationGlobalSettingRequest,
  ): Observable<ApplicationGlobalSettingResponse[]> {
    let url = `${this.apiLookupBase}`;
    const params = new URLSearchParams();
    if (
      payload.applicationTitleBC &&
      payload.applicationTitleBC.trim() !== ''
    ) {
      params.set('applicationTitleBC', payload.applicationTitleBC);
    }
    if (
      payload.applicationSettingBC &&
      payload.applicationSettingBC.trim() !== ''
    ) {
      params.set('applicationSettingBC', payload.applicationSettingBC);
    }
    if (payload.search && payload.search.trim() !== '') {
      params.set('search', payload.search);
    }
    if (
      payload.sortModel &&
      payload.sortModel.column &&
      payload.sortModel.direction
    ) {
      params.set('sort', payload.sortModel.column);
      params.set('sortOrder', payload.sortModel.direction);
    }
    url += `?${params.toString()}`;
    return httpService.getJSON(url);
  }

  public deleteApplicationGlobalSetting(
    applicationGlobalSettingID: number,
  ): Observable<any> {
    return httpService.deleteJSON(
      `${this.apiLookupBase}/${applicationGlobalSettingID}`,
    );
  }

  public createApplicationGlobalSetting(
    payload: CreateApplicationGlobalSettingRequest,
  ): Observable<ApplicationGlobalSettingResponse> {
    return httpService.postJSON(`${this.apiLookupBase}`, payload);
  }

  public updateApplicationGlobalSetting(
    payload: UpdateApplicationGlobalSettingRequest,
  ): Observable<ApplicationGlobalSettingResponse> {
    return httpService.patchJSON(
      `${this.apiLookupBase}/${payload.applicationSettingID}`,
      { applicationSettingValue: payload.applicationSettingValue },
    );
  }
}

const settingsService = new SettingsService();

export default settingsService;
